export default {
  submitting: false,
  request: {
    dedicatedMasterAccount: null, // Yes SPP, No PPA
    accountModel: null,
    sppContractType: null,
    awsSupportLevel: null,
    linkedAccountsType: null,
    contractSignatureDate: null,
    opportunityId: null,
    edpContract: null,
    controlTowerRequired: null,
    clientName: null,
    clientSfdcid: null,
    serviceLine: null,
    businessUnit: null,
    saasModel: null,
    businessJustification: null,
    controlTowerRegions: [],
    controlTowerGuardRail: null,
    controlTowerCloudTrail: null,
    requestorName: null,
    requestorEmail: null,
    requestorId: null,
  },
  masterpayerRequestHeaders: [
    {
      sortable: false,
      text: 'Actions',
      value: 'action'
    },
    {
      sortable: false,
      text: 'Status',
      value: 'Status'
    },
    {
      sortable: false,
      text: 'Dedicated Master Account',
      value: 'Dedicated_Master_Account'
    },
    {
      sortable: false,
      text: 'Client Name',
      value: 'Client_Name'
    },
    {
      sortable: false,
      text: 'Client SFDC ID',
      value: 'Client_SFDC_ID'
    },
    {
      sortable: false,
      text: 'Service Line',
      value: 'Service_Line'
    },
    {
      sortable: false,
      text: 'Business Unit',
      value: 'Business_Unit'
    },
    {
      sortable: false,
      text: 'Saas Model',
      value: 'Saas_Model'
    },
    {
      sortable: false,
      text: 'Account Model',
      value: 'Account_Model'
    },
    {
      sortable: false,
      text: 'Business Justification',
      value: 'Business_Justification'
    },
    {
      sortable: false,
      text: 'SPP Contract Type',
      value: 'SPP_Contract_Type'
    },
    {
      sortable: false,
      text: 'AWS Support Level',
      value: 'AWS_Support_Type'
    },
    {
      sortable: false,
      text: 'Linked Accounts Type',
      value: 'Linked_Accounts_Type'
    },
    {
      sortable: false,
      text: 'Contract Signature Date',
      value: 'Contract_Signature_Date'
    },
    {
      sortable: false,
      text: 'Opportunity Id',
      value: 'Opportunity_Id'
    },
    {
      sortable: false,
      text: 'Edp Contract',
      value: 'Edp_Contract'
    },
    {
      sortable: false,
      text: 'Control Tower Required',
      value: 'Control_Tower_Required'
    },
    {
      sortable: false,
      text: 'Control Tower Regions',
      value: 'Control_Tower_Regions'
    },
    {
      sortable: false,
      text: 'Control Tower Guard Rail',
      value: 'Control_Tower_Guard_Rail'
    },
    {
      sortable: false,
      text: 'Control Tower Cloud Trail',
      value: 'Control_Tower_Cloud_Trail'
    },
    {
      sortable: true,
      text: 'Created At',
      value: 'Created_At'
    },
    {
      sortable: true,
      text: 'Updated At',
      value: 'Updated_At'
    }
  ],
  masterpayerRequest: [],
  masterpayerRequestLoading: true
}
